import { ListGroup, ListHeader, ListItem, ListItemSubgroup, TokensAndVaultsLabel } from "."
import { P } from "../../../shared_components/Library/Typeography"
import { Box } from "../../../shared_components/UI/Box"
import { Divider } from './styles'
import Link01 from "../../../shared_components/Icons/Link01"
import Mail01 from "../../../shared_components/Icons/Mail01"
import routes from "../../../router/routes"
import Safe from "../../../shared_components/Icons/Safe"
import File from "../../../shared_components/Icons/File"
import EditProfile from "../../../shared_components/Icons/Profile"

const myZapRoutes = routes.myzap

function MyZapMobileMenu() {
  return (
    <Box dc g={16}>
      <ListGroup>
        <P s="S" c="text-secondary" ta="right" padH={8}>Settings</P>
        <ListItemSubgroup>
          <ListItem
            Icon={EditProfile}
            label="Edit Profile"
            textColor="text-primary"
            path={myZapRoutes.profile}
            showIndicator
          />
          <ListItem
            Icon={Link01}
            label="Socials"
            textColor="text-primary"
            path={myZapRoutes.socials}
            showIndicator
          />
          <ListItem
            Icon={Mail01}
            label="Communications"
            textColor="text-primary"
            path={myZapRoutes.communications}
            showIndicator
          />
        </ListItemSubgroup>
      </ListGroup>
      <Divider />
      <ListGroup>
        <ListHeader label="Staking & Claiming" />
        <ListItem
          Icon={Safe}
          label={<TokensAndVaultsLabel />}
          path={myZapRoutes.tokensAndVaults}
          textColor="text-primary"
          showIndicator
        />
        <ListItem
          Icon={File}
          label="Claiming history"
          path={myZapRoutes.claimingHistory}
          textColor="text-primary"
          showIndicator
        />
      </ListGroup>
    </Box>
  )
}

export default MyZapMobileMenu